import React, { useState } from 'react';
import { Upload, Button, Image, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadDishCoverImage } from '../../services/uploadService';

type Props = {
  label: string;
  value?: string | null;
  previewUrl?: string | null;
  onChange?: (url: string, previewUrl?: string) => void;
  disabled?: boolean;
};

export function AdminImageUpload({
  label,
  value,
  previewUrl,
  onChange,
  disabled,
}: Props) {
  const [uploading, setUploading] = useState(false);
  const displayUrl = previewUrl || value || undefined;

  const handleUpload = async (file: File) => {
    setUploading(true);
    try {
      const { url, signedUrl } = await uploadDishCoverImage(file);
      onChange?.(url, signedUrl || url);
      message.success('Đã tải ảnh lên');
    } catch (e: unknown) {
      const err = e as { message?: string };
      message.error(err.message || 'Upload thất bại');
    } finally {
      setUploading(false);
    }
    return false;
  };

  return (
    <div>
      <div style={{ marginBottom: 8, color: 'rgba(0,0,0,0.65)' }}>{label}</div>
      {displayUrl ? (
        <Image
          src={displayUrl}
          alt={label}
          width={140}
          height={100}
          style={{ objectFit: 'cover', borderRadius: 8, marginBottom: 8 }}
        />
      ) : null}
      <Upload
        accept="image/*"
        showUploadList={false}
        beforeUpload={file => {
          void handleUpload(file);
          return false;
        }}
        disabled={disabled || uploading}
      >
        <Button
          icon={<UploadOutlined />}
          loading={uploading}
          disabled={disabled}
        >
          {value ? 'Đổi ảnh' : 'Tải ảnh lên'}
        </Button>
      </Upload>
    </div>
  );
}
